export default __webpack_public_path__ + "static/media/Icon-Chevron-Right.d27e5a48.svg";